export const DataSourcesInInsert = {
  flow: 'y',
  gap: 'A',
  CaptionTitle: {
    Text: {
      text: '{{ editor.insert.dataSources | polyglot }}'
    }
  },
  Flex: {
    gap: 'A',
    flow: 'y',
    margin: '- -Z2',
    childExtends: 'IntegrationsItem',
    childrenAs: 'state',
    childProps: {
      Button: {
        text: '{{ common.action.add | polyglot }}'
      }
    },
    children: [
      {
        icon: 'plus',
        title: 'editor.canvasBg.custom',
        descr: 'editor.insert.customDataSourceDescr',
        onConnect: (el, s) => {},
        onAdd: (el, s) => {
          el.setWindow('docs', '/fetch')
        }
      }
    ]
  }
}
